import { memo } from "react";

const { TableRow, TableCell } = require("@material-ui/core");

const GroupTotalRow = ({ total, columns }) => {
  const formattedTotal = `${(total.totalAmount ?? 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 5,
  })}`;
  const formattedIssAmountTotal = `${(total.issAmount ?? 0).toLocaleString(
    "pt-BR",
    {
      minimumFractionDigits: 2,
      maximumFractionDigits: 5,
    }
  )}`;

  return (
    <TableRow style={{ backgroundColor: "#d6e5ff" }}>
      <TableCell size="small" colSpan={6} align="left">
        Total
      </TableCell>
      <TableCell
        size="small"
        colSpan={1}
        align="right"
        style={{ paddingRight: 16 }}
      >
        {formattedTotal}
      </TableCell>
      <TableCell size="small" colSpan={1} align="left" />
      <TableCell
        size="small"
        colSpan={1}
        align="right"
        style={{ paddingRight: 16 }}
      >
        {formattedIssAmountTotal}
      </TableCell>
      <TableCell size="small" colSpan={1} align="left" />
    </TableRow>
  );
};

export default memo(GroupTotalRow);
